import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=10c0d45a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=10c0d45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c0d45a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c0d45a')) {
      api.createRecord('10c0d45a', component.options)
    } else {
      api.reload('10c0d45a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=10c0d45a&scoped=true&", function () {
      api.rerender('10c0d45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2COH0VANCSZxP/JS/comp/GuestBox.vue"
export default component.exports